import React, { useState } from "react";
import { Actif, Site } from "../../interfaces";
import CustomDialog from "../CustomDialog";
import { getEntityInformation } from "./EntityInformations";

interface ArobrescenceProps {
  site: Site;
  checkbox: boolean;
  youractif?: boolean;
  setSelectedBâtiments?: any;
  setSelectedNiveaux?: any;
  setSelectedEspaces?: any;
  setSelectedPieces?: any;
  selectedBâtiments?: any;
  selectedNiveaux?: any;
  selectedEspaces?: any;
  selectedPieces?: any;
}

export const ArborescenceBâtimentaire: React.FC<ArobrescenceProps> = ({
  site,
  checkbox,
  youractif,
  setSelectedBâtiments,
  setSelectedNiveaux,
  setSelectedEspaces,
  setSelectedPieces,
  selectedBâtiments,
  selectedNiveaux,
  selectedEspaces,
  selectedPieces,
}) => {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntityType, setSelectedEntityType] = useState<string>("");

  const [modals, setModals] = useState({
    bâtiment: false,
    niveau: false,
    espace: false,
    pièce: false,
  });

  const openModal = (modalName, entity) => {
    setModals({ ...modals, [modalName]: true });
    setSelectedEntityType(modalName);
    setSelectedEntity(entity);
  };
  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
    setSelectedEntityType("");
    setSelectedEntity(null);
  };

  const handleSelection = (e, id, selectedItems, setSelectedItems) => {
    setSelectedItems((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };

  return (
    <>
      {site?.batiments?.map((batiment) => (
        <>
          <div className="flex space-x-2" key={batiment?.id}>
            <img src="/images/prochain.png" className="w-8 h-8" />
            {checkbox
              ? batiment.actif_id === null && (
                  <div className="flex items-center">
                    <input
                      id="checkbox-table-search-1"
                      type="checkbox"
                      checked={selectedBâtiments?.includes(batiment.id)}
                      onChange={(e) =>
                        handleSelection(
                          e,
                          batiment.id,
                          selectedBâtiments,
                          setSelectedBâtiments
                        )
                      }
                      className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      htmlFor="checkbox-table-search-1"
                      className="sr-only"
                    >
                      checkbox
                    </label>
                  </div>
                )
              : null}

            <button
              type="button"
              onClick={() => openModal("bâtiment", batiment)}
              className={` bg-white flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md ${
                youractif
                  ? " cursor-not-allowed blur-[2px]  "
                  : "hover:bg-gray-200"
              }  `}
              disabled={youractif}
            >
              <div className="flex space-x-3">
                <img src="/images/batiments-3d.png" className="w-6 h-6" />
                <span>{batiment?.nom_bâtiment} </span>
              </div>
            </button>
          </div>
          {batiment.niveaux
            ?.sort((a, b) => a.numero - b.numero)
            .map((niveau) => (
              <>
                <div className="flex space-x-2 ml-10" key={niveau?.id}>
                  <img src="/images/prochain.png" className="w-8 h-8" />
                  {checkbox
                    ? niveau.actif_id === null && (
                        <div className="flex items-center">
                          <input
                            id="checkbox-table-search-1"
                            type="checkbox"
                            checked={selectedNiveaux?.includes(niveau.id)}
                            onChange={(e) =>
                              handleSelection(
                                e,
                                niveau.id,
                                selectedNiveaux,
                                setSelectedNiveaux
                              )
                            }
                            className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="checkbox-table-search-1"
                            className="sr-only"
                          >
                            checkbox
                          </label>
                        </div>
                      )
                    : null}

                  <button
                    type="button"
                    onClick={() => openModal("niveau", niveau)}
                    disabled={youractif}
                    className={`flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md ${
                      youractif
                        ? "cursor-not-allowed blur-[2px]"
                        : "hover:bg-gray-200"
                    }  `}
                  >
                    <div className="flex space-x-3">
                      <img src="/images/couches.png" className="w-6 h-6" />
                      <span>{niveau?.nom_niveau}</span>
                    </div>
                  </button>
                </div>
                {niveau.espaces?.map((espace) => (
                  <>
                    <div className="flex space-x-2 ml-20" key={espace?.id}>
                      <img src="/images/prochain.png" className="w-8 h-8" />
                      {checkbox
                        ? espace.actif_id === null && (
                            <div className="flex items-center">
                              <input
                                id="checkbox-table-search-1"
                                type="checkbox"
                                checked={selectedEspaces?.includes(espace.id)}
                                onChange={(e) =>
                                  handleSelection(
                                    e,
                                    espace.id,
                                    selectedEspaces,
                                    setSelectedEspaces
                                  )
                                }
                                className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                              />
                              <label
                                htmlFor="checkbox-table-search-1"
                                className="sr-only"
                              >
                                checkbox
                              </label>
                            </div>
                          )
                        : null}

                      <button
                        type="button"
                        onClick={() => openModal("espace", espace)}
                        disabled={youractif}
                        className={` flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md ${
                          youractif
                            ? "cursor-not-allowed blur-[2px]"
                            : "hover:bg-gray-200"
                        }  `}
                      >
                        <div className="flex space-x-3">
                          <img src="/images/espace.png" className="w-6 h-6" />
                          <span>{espace?.nom_espace}</span>
                        </div>
                      </button>
                    </div>
                    {espace.pieces
                      ?.sort((a, b) => a.nom_piece.localeCompare(b.nom_piece))
                      .map((piece) => (
                        <div className="flex space-x-2 ml-32" key={piece?.id}>
                          <img src="/images/prochain.png" className="w-8 h-8" />
                          {checkbox
                            ? piece.actif_id === null && (
                                <div className="flex items-center">
                                  <input
                                    id="checkbox-table-search-1"
                                    type="checkbox"
                                    checked={selectedPieces?.includes(piece.id)}
                                    onChange={(e) =>
                                      handleSelection(
                                        e,
                                        piece.id,
                                        selectedPieces,
                                        setSelectedPieces
                                      )
                                    }
                                    className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                  />
                                  <label
                                    htmlFor="checkbox-table-search-1"
                                    className="sr-only"
                                  >
                                    checkbox
                                  </label>
                                </div>
                              )
                            : null}

                          <button
                            type="button"
                            onClick={() => openModal("pièce", piece)}
                            disabled={youractif}
                            className={` flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md ${
                              youractif
                                ? "cursor-not-allowed blur-[2px]"
                                : "hover:bg-gray-200"
                            }  `}
                          >
                            <div className="flex space-x-3">
                              <img
                                src="/images/piece.png"
                                className="w-6 h-6"
                              />
                              <span>{piece?.nom_piece}</span>
                            </div>
                          </button>
                        </div>
                      ))}
                  </>
                ))}
              </>
            ))}
        </>
      ))}
      {selectedEntityType && (
        <CustomDialog
          visible={modals[selectedEntityType]}
          closeModalDialog={() => closeModal(selectedEntityType)}
        >
          <div className="relative w-full h-full ">
            {getEntityInformation(selectedEntity, selectedEntityType)}
          </div>
        </CustomDialog>
      )}
    </>
  );
};

interface ArobrescencePropsV2 {
  site: Site;
  actif?: Actif;
  batimentIds?: any;
  niveauIds?: any;
  espaceIds?: any;
  pieceIds?: any;
  setSelectedBâtiments?: any;
  setSelectedNiveaux?: any;
  setSelectedEspaces?: any;
  setSelectedPieces?: any;
  selectedBâtiments?: any;
  selectedNiveaux?: any;
  selectedEspaces?: any;
  selectedPieces?: any;
  selectedUnités?: any;
  checkbox: boolean;
}

// Arborescence actif + Correspondance d'unité
export const ArborescenceBâtimentaireV2: React.FC<ArobrescencePropsV2> = ({
  site,
  actif,
  checkbox,
  batimentIds,
  niveauIds,
  espaceIds,
  pieceIds,
  setSelectedBâtiments,
  setSelectedNiveaux,
  setSelectedEspaces,
  setSelectedPieces,
  selectedBâtiments,
  selectedNiveaux,
  selectedEspaces,
  selectedPieces,
  selectedUnités,
}) => {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntityType, setSelectedEntityType] = useState("");

  const [modals, setModals] = useState({
    bâtiment: false,
    niveau: false,
    espace: false,
    pièce: false,
  });

  const openModal = (modalName, entity) => {
    setModals({ ...modals, [modalName]: true });
    setSelectedEntityType(modalName);
    setSelectedEntity(entity);
  };
  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
    setSelectedEntityType("");
    setSelectedEntity(null);
  };

  const handleSelection = (e, id, selectedItems, setSelectedItems) => {
    setSelectedItems((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };

  return (
    <>
      {site?.batiments?.map((batiment) => (
        <>
          <div className="flex space-x-2" key={batiment?.id}>
            <img src="/images/prochain.png" className="w-8 h-8" />
            {checkbox &&
              actif?.bâtiments.find((entity) => entity.id === batiment.id) && (
                <div className="flex items-center">
                  <input
                    id="checkbox-table-search-1"
                    type="checkbox"
                    checked={selectedBâtiments?.includes(batiment.id)}
                    onChange={(e) =>
                      handleSelection(
                        e,
                        batiment.id,
                        selectedBâtiments,
                        setSelectedBâtiments
                      )
                    }
                    className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
              )}
            <button
              type="button"
              onClick={() => openModal("bâtiment", batiment)}
              className={`  flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                batimentIds.includes(batiment.id)
                  ? "hover:bg-gray-200"
                  : "   bg-gray-300"
              }  ${
                selectedUnités?.some((unité) =>
                  unité?.bâtiments?.some((data) => data.id === batiment.id)
                )
                  ? "border-gexpertise-200 border-4"
                  : "border-gray-400"
              }  `}
            >
              <div className="flex space-x-3">
                <img src="/images/batiments-3d.png" className="w-6 h-6" />
                <span>{batiment?.nom_bâtiment} </span>
              </div>
            </button>
          </div>
          {batiment.niveaux
            ?.sort((a, b) => a.numero - b.numero)
            .map((niveau) => (
              <>
                <div className="flex space-x-2 ml-10" key={niveau?.id}>
                  <img src="/images/prochain.png" className="w-8 h-8" />
                  {checkbox &&
                    actif?.niveaux.find(
                      (entity) => entity.id === niveau.id
                    ) && (
                      <div className="flex items-center">
                        <input
                          id="checkbox-table-search-1"
                          type="checkbox"
                          checked={selectedNiveaux?.includes(niveau.id)}
                          onChange={(e) =>
                            handleSelection(
                              e,
                              niveau.id,
                              selectedNiveaux,
                              setSelectedNiveaux
                            )
                          }
                          className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </div>
                    )}
                  <button
                    type="button"
                    onClick={() => openModal("niveau", niveau)}
                    className={`flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                      niveauIds.includes(niveau.id)
                        ? "hover:bg-gray-200"
                        : "  bg-gray-300"
                    }  ${
                      selectedUnités?.some((unité) =>
                        unité?.niveaux?.some((data) => data.id === niveau.id)
                      )
                        ? "border-gexpertise-200 border-4"
                        : "border-gray-400"
                    } `}
                  >
                    <div className="flex space-x-3">
                      <img src="/images/couches.png" className="w-6 h-6" />
                      <span>{niveau?.nom_niveau}</span>
                    </div>
                  </button>
                </div>
                {niveau.espaces?.map((espace) => (
                  <>
                    <div className="flex space-x-2 ml-20" key={espace?.id}>
                      <img src="/images/prochain.png" className="w-8 h-8" />
                      {checkbox &&
                        actif?.espaces.find(
                          (entity) => entity.id === espace.id
                        ) && (
                          <div className="flex items-center">
                            <input
                              id="checkbox-table-search-1"
                              type="checkbox"
                              checked={selectedEspaces?.includes(espace.id)}
                              onChange={(e) =>
                                handleSelection(
                                  e,
                                  espace.id,
                                  selectedEspaces,
                                  setSelectedEspaces
                                )
                              }
                              className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </div>
                        )}

                      <button
                        type="button"
                        onClick={() => openModal("espace", espace)}
                        className={` flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                          espaceIds.includes(espace.id)
                            ? "hover:bg-gray-200"
                            : " bg-gray-300"
                        }   ${
                          selectedUnités?.some((unité) =>
                            unité?.espaces?.some(
                              (data) => data.id === espace.id
                            )
                          )
                            ? "border-gexpertise-200 border-4"
                            : "border-gray-400"
                        } `}
                      >
                        <div className="flex space-x-3">
                          <img src="/images/espace.png" className="w-6 h-6" />
                          <span>{espace?.nom_espace}</span>
                        </div>
                      </button>
                    </div>
                    {espace.pieces
                      ?.sort((a, b) => a.nom_piece.localeCompare(b.nom_piece))
                      .map((piece) => (
                        <div className="flex space-x-2 ml-32" key={piece?.id}>
                          <img src="/images/prochain.png" className="w-8 h-8" />
                          {checkbox &&
                            actif?.pieces.find(
                              (entity) => entity.id === piece.id
                            ) && (
                              <div className="flex items-center">
                                <input
                                  id="checkbox-table-search-1"
                                  type="checkbox"
                                  checked={selectedPieces?.includes(piece.id)}
                                  onChange={(e) =>
                                    handleSelection(
                                      e,
                                      piece.id,
                                      selectedPieces,
                                      setSelectedPieces
                                    )
                                  }
                                  className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                />
                              </div>
                            )}

                          <button
                            type="button"
                            onClick={() => openModal("pièce", piece)}
                            className={`flex px-3 py-1  font-semibold text-md text-black border rounded-md ${
                              pieceIds.includes(piece.id)
                                ? "hover:bg-gray-200"
                                : " bg-gray-300"
                            }  ${
                              selectedUnités?.some((unité) =>
                                unité?.pieces?.some(
                                  (data) => data.id === piece.id
                                )
                              )
                                ? "border-gexpertise-200 border-4"
                                : "border-gray-400"
                            }`}
                          >
                            <div className="flex space-x-3">
                              <img
                                src="/images/piece.png"
                                className="w-6 h-6"
                              />
                              <span>{piece?.nom_piece}</span>
                            </div>
                          </button>
                        </div>
                      ))}
                  </>
                ))}
              </>
            ))}
        </>
      ))}
      {selectedEntityType && (
        <CustomDialog
          visible={modals[selectedEntityType]}
          closeModalDialog={() => closeModal(selectedEntityType)}
        >
          <div className="relative w-full h-full  ">
            {getEntityInformation(selectedEntity, selectedEntityType)}
          </div>
        </CustomDialog>
      )}
    </>
  );
};

interface ArobrescencePropsV3 {
  site: Site;
  actif?: Actif;
  batimentIds?: any;
  niveauIds?: any;
  espaceIds?: any;
  pieceIds?: any;
  setSelectedBâtiments?: any;
  setSelectedNiveaux?: any;
  setSelectedEspaces?: any;
  setSelectedPieces?: any;
  selectedBâtiments?: any;
  selectedNiveaux?: any;
  selectedEspaces?: any;
  selectedPieces?: any;
  selectedUnités?: any;
  checkbox: boolean;
}

// Edit correspondance Classeur
export const ArborescenceBâtimentaireV3: React.FC<ArobrescencePropsV3> = ({
  site,
  actif,
  checkbox,
  batimentIds,
  niveauIds,
  espaceIds,
  pieceIds,
  setSelectedBâtiments,
  setSelectedNiveaux,
  setSelectedEspaces,
  setSelectedPieces,
  selectedBâtiments,
  selectedNiveaux,
  selectedEspaces,
  selectedPieces,
  selectedUnités,
}) => {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntityType, setSelectedEntityType] = useState("");

  const [modals, setModals] = useState({
    bâtiment: false,
    niveau: false,
    espace: false,
    pièce: false,
  });

  const openModal = (modalName, entity) => {
    setModals({ ...modals, [modalName]: true });
    setSelectedEntityType(modalName);
    setSelectedEntity(entity);
  };
  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
    setSelectedEntityType("");
    setSelectedEntity(null);
  };

  const handleSelection = (e, id, setSelectedItems) => {
    setSelectedItems((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };

  return (
    <>
      {site?.batiments?.map((batiment) => (
        <>
          <div className="flex space-x-2" key={batiment?.id}>
            <img src="/images/prochain.png" className="w-8 h-8" />
            {checkbox &&
              actif?.bâtiments.find((entity) => entity.id === batiment.id) && (
                <div className="flex items-center">
                  <input
                    id="checkbox-table-search-1"
                    type="checkbox"
                    checked={selectedBâtiments?.includes(batiment.id)}
                    onChange={(e) =>
                      handleSelection(e, batiment.id, setSelectedBâtiments)
                    }
                    className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
              )}
            <button
              type="button"
              onClick={() => openModal("bâtiment", batiment)}
              className={`  flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                batimentIds.includes(batiment.id)
                  ? "hover:bg-gray-200"
                  : "   bg-gray-300"
              }  ${
                selectedUnités?.some((unité) =>
                  unité?.bâtiments?.some((data) => data.id === batiment.id)
                )
                  ? "border-gexpertise-200 border-4"
                  : "border-gray-400"
              }  `}
            >
              <div className="flex space-x-3">
                <img src="/images/batiments-3d.png" className="w-6 h-6" />
                <span>{batiment?.nom_bâtiment} </span>
              </div>
            </button>
          </div>
          {batiment.niveaux
            ?.sort((a, b) => a.numero - b.numero)
            .map((niveau) => (
              <>
                <div className="flex space-x-2 ml-10" key={niveau?.id}>
                  <img src="/images/prochain.png" className="w-8 h-8" />
                  {checkbox &&
                    actif?.niveaux.find(
                      (entity) => entity.id === niveau.id
                    ) && (
                      <div className="flex items-center">
                        <input
                          id="checkbox-table-search-1"
                          type="checkbox"
                          checked={selectedNiveaux?.includes(niveau.id)}
                          onChange={(e) =>
                            handleSelection(e, niveau.id, setSelectedNiveaux)
                          }
                          className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </div>
                    )}
                  <button
                    type="button"
                    onClick={() => openModal("niveau", niveau)}
                    className={`flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                      niveauIds.includes(niveau.id)
                        ? "hover:bg-gray-200"
                        : "  bg-gray-300"
                    }  ${
                      selectedUnités?.some((unité) =>
                        unité?.niveaux?.some((data) => data.id === niveau.id)
                      )
                        ? "border-gexpertise-200 border-4"
                        : "border-gray-400"
                    } `}
                  >
                    <div className="flex space-x-3">
                      <img src="/images/couches.png" className="w-6 h-6" />
                      <span>{niveau?.nom_niveau}</span>
                    </div>
                  </button>
                </div>
                {niveau.espaces?.map((espace) => (
                  <>
                    <div className="flex space-x-2 ml-20" key={espace?.id}>
                      <img src="/images/prochain.png" className="w-8 h-8" />
                      {checkbox &&
                        actif?.espaces.find(
                          (entity) => entity.id === espace.id
                        ) && (
                          <div className="flex items-center">
                            <input
                              id="checkbox-table-search-1"
                              type="checkbox"
                              checked={selectedEspaces?.includes(espace.id)}
                              onChange={(e) =>
                                handleSelection(
                                  e,
                                  espace.id,
                                  setSelectedEspaces
                                )
                              }
                              className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </div>
                        )}

                      <button
                        type="button"
                        onClick={() => openModal("espace", espace)}
                        className={` flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                          espaceIds.includes(espace.id)
                            ? "hover:bg-gray-200"
                            : " bg-gray-300"
                        }   ${
                          selectedUnités?.some((unité) =>
                            unité?.espaces?.some(
                              (data) => data.id === espace.id
                            )
                          )
                            ? "border-gexpertise-200 border-4"
                            : "border-gray-400"
                        } `}
                      >
                        <div className="flex space-x-3">
                          <img src="/images/espace.png" className="w-6 h-6" />
                          <span>{espace?.nom_espace}</span>
                        </div>
                      </button>
                    </div>
                    {espace.pieces
                      ?.sort((a, b) => a.nom_piece.localeCompare(b.nom_piece))
                      .map((piece) => (
                        <div className="flex space-x-2 ml-32" key={piece?.id}>
                          <img src="/images/prochain.png" className="w-8 h-8" />
                          {checkbox &&
                            actif?.pieces.find(
                              (entity) => entity.id === piece.id
                            ) && (
                              <div className="flex items-center">
                                <input
                                  id="checkbox-table-search-1"
                                  type="checkbox"
                                  checked={selectedPieces?.includes(piece.id)}
                                  onChange={(e) =>
                                    handleSelection(
                                      e,
                                      piece.id,
                                      setSelectedPieces
                                    )
                                  }
                                  className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                />
                              </div>
                            )}

                          <button
                            type="button"
                            onClick={() => openModal("pièce", piece)}
                            className={`flex px-3 py-1  font-semibold text-md text-black border rounded-md ${
                              pieceIds.includes(piece.id)
                                ? "hover:bg-gray-200"
                                : " bg-gray-300"
                            }  ${
                              selectedUnités?.some((unité) =>
                                unité?.pieces?.some(
                                  (data) => data.id === piece.id
                                )
                              )
                                ? "border-gexpertise-200 border-4"
                                : "border-gray-400"
                            }`}
                          >
                            <div className="flex space-x-3">
                              <img
                                src="/images/piece.png"
                                className="w-6 h-6"
                              />
                              <span>{piece?.nom_piece}</span>
                            </div>
                          </button>
                        </div>
                      ))}
                  </>
                ))}
              </>
            ))}
        </>
      ))}
      {selectedEntityType && (
        <CustomDialog
          visible={modals[selectedEntityType]}
          closeModalDialog={() => closeModal(selectedEntityType)}
        >
          <div className="relative w-full h-full  ">
            {getEntityInformation(selectedEntity, selectedEntityType)}
          </div>
        </CustomDialog>
      )}
    </>
  );
};
